import { useState, useEffect, useRef } from 'react';
import { producaov2 } from '../../../../services/apis';
import { normalizeSubscriptionsFilters } from './utils';

const defaultSubscriptionFilters = {
  user: null,
  plan: null,
  status: undefined,
  dueDateType: undefined
};

export const useSubscriptionFilter = (defaultFilters = defaultSubscriptionFilters) => {
  const [filters, setFilters] = useState(defaultFilters);

  const changeFilter = (filter, value) => {
    setFilters(prev => ({...prev, [filter]: value}));
  }

  const changeFilters = (filters) => {
    setFilters(filters);
  }

  const clearFilter = (filter) => {
    setFilters(prev => ({...prev, [filter]: defaultSubscriptionFilters[filter]}));
  }

  const clearAllFilters = () => {
    setFilters(defaultSubscriptionFilters);
  }

  return {
    filters,
    changeFilter,
    changeFilters,
    clearFilter,
    clearAllFilters
  }
}

export const useSubscriptions = ({filters} = {}) => {
  const lastPage = useRef(null);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState([]);
  const [error, setError] = useState([]);
  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(() => {
    const getSubscriptions = async () => {
      // if(lastPage.current === page) {
      //   return;
      // }

      setIsLoading(true);

      try {
        const normalizedFilters = normalizeSubscriptionsFilters(filters);

        const response = await producaov2.get('faturasV2/subscriptions', {
          params: {
            ...normalizedFilters,
            limit: rowsPerPage,
            page: page + 1
          }
        });

        setData(response.data);
      } catch(error) {
        setError(error?.response?.data);
      } finally {
        setIsLoading(false);
      }
    }

    getSubscriptions();
  }, [filters, page, rowsPerPage, refreshCount]);

  const changePage = (newPage) => {
    lastPage.current = page;
    setPage(newPage);
  }

  const changeRowsPerPage = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage);
  }

  const refreshData = () => {
    setRefreshCount(prev => prev + 1);
  }

  return {
    data,
    page,
    rowsPerPage,
    isLoading,
    error,
    changePage,
    changeRowsPerPage,
    refreshData
  }
}

